<template>
  <div class="page-table scrollable only-y">
    <el-dialog
      width="440px"
      :visible="filterVisible"
      :before-close="handleCloseFilter"
      :close-on-click-modal="false"
    >
      <h2 class="form-section-header">
        Filter Settings
      </h2>

      <el-form class="form-modal">
        <h3 class="black-text mb-5">Select Date Range</h3>
        <el-date-picker
          class="mb-10"
          style="width: 100%;"
          v-model="historyDateRange"
          type="daterange"
          align="right"
          unlink-panels
          format="yyyy-MM-dd"
          :clearable="false"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          :picker-options="dateFilterOptions"
        >
        </el-date-picker>
        <dads-select
          v-model="orderStatus"
          filterable
          clearable
          placeholder="Select Status"
        >
          <template slot="prefix">Select Status</template>
          <el-option
            v-for="{ label, value } in orderStatusOptions"
            :key="value"
            :label="label"
            :value="value"
          />
        </dads-select>

        <el-button class="mt-20" @click="doAdvanced">
          Update
        </el-button>
      </el-form>
    </el-dialog>

    <div class="no-table-box page-header">
      <div class="flex justify-space-between align-center pb-15">
        <h1>
          <v-svg class="voxo-aqua" sprite="call-forward" />
          Port Requests
        </h1>
        <el-tag class="hidden-xs-only">
          <i class="el-icon-info" style="margin-right: 4px;"></i>
          Total : {{ tableData.length }}
        </el-tag>
      </div>

      <div class="flex pb-20">
        <div class="box">
          <el-input v-model="search" placeholder="Search" clearable> </el-input>
          <dads-select
            class="ml-10 mr-5"
            v-model="filterType"
            placeholder="Filter Type"
          >
            <el-option
              v-for="type in filterTypeOptions"
              :key="type"
              :label="type"
              :value="type"
            ></el-option>
          </dads-select>

          <el-button @click="filterVisible = true" class="ml-5">
            Filter
          </el-button>
        </div>
        <div class="box right">
          <el-dropdown>
            <el-button>
              New Request
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="openCreate('phoneNumber')">
                <v-svg class="success-text" sprite="telephone-2" />
                Phone Number
              </el-dropdown-item>
              <el-dropdown-item @click.native="openCreate('tollFree')">
                <v-svg class="voxo-orange" sprite="fax-2" />
                Toll Free
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          :sort-config="{
            defaultSort: { field: 'desiredDueDate', order: 'desc' }
          }"
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="filteredData()"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <normal-port-request
      v-if="portType === 'phoneNumber'"
      :createVisible="createVisible"
      :clearFields="clearFields"
      :locationOptions="locationOptions"
      :datePickerOptions="datePickerOptions"
      :portReqProcessing="processing"
      @portRequest="submitNewRequest('phoneNumber', $event)"
      @cancelOperation="cancelCreateOperation"
    />

    <toll-free-port-request
      v-if="portType === 'tollFree'"
      :createVisible="createVisible"
      :clearFields="clearFields"
      :portReqProcessing="processing"
      @newTollFreeRequest="submitNewRequest('tollFree', $event)"
      @cancelOperation="cancelCreateOperation"
    />

    <normal-edit-form
      v-if="portType === 'Normal'"
      :editVisible="editVisible"
      :processing="processing"
      :selectedPortOrder="selectedPortOrder"
      :locationOptions="locationOptions"
      :clearFields="clearFields"
      :datePickerOptions="datePickerOptions"
      @cancelOperation="cancelEditOperation"
      @editOrder="submitPortEdit('phoneNumber', $event)"
    />

    <toll-free-edit-form
      v-if="portType === 'Toll free'"
      :editVisible="editVisible"
      :processing="processing"
      :selectedPortOrder="selectedPortOrder"
      :clearFields="clearFields"
      @editOrder="submitPortEdit('tollFree', $event)"
      @cancelOperation="cancelEditOperation"
    />

    <div id="places-div" style="display:none;">
      <div></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import feathersClient, { hostServer } from "@/feathers/feathers-client";

import TollFreePortRequest from "./components/tollFreePortRequest.vue";
import TollFreeEditForm from "./components/tollFreeEditForm.vue";
import NormalEditForm from "./components/normalEditForm.vue";
import NormalPortRequest from "./components/normalPortRequest.vue";

import DadsSelect from "@/components/select";
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: "PortRequestTable",

  components: {
    TollFreePortRequest,
    TollFreeEditForm,
    NormalEditForm,
    NormalPortRequest,
    DadsSelect
  },

  data() {
    return {
      tableData: [],

      filterVisible: false,
      historyDateRange: [moment(), moment()],
      orderStatus: "",
      orderStatusOptions: [
        {
          label: "Canceled",
          value: "CNCL"
        },
        {
          label: "Closed",
          value: "CLSD"
        },
        {
          label: "Incomplete",
          value: "INCOMPLT"
        },
        {
          label: "Pending",
          value: "PENDING"
        },
        {
          label: "Pending Cancel",
          value: "PCNCL"
        }
      ],

      search: "",
      filterTypeOptions: ["All", "Normal", "Toll free"],
      filterType: "All",
      visibleActionsId: "",
      modalModelId: "",
      editVisible: false,
      createVisible: false,
      processing: false,
      tableLoading: false,

      locationOptions: ["BLDG", "FL", "STE", "APT"],

      portType: "",
      clearFields: false,

      orderData: [],
      selectedPortOrder: null,
      gridData: [],

      datePickerOptions: {
        disabledDate(time) {
          let checkDate = new Date(time);
          let dateNow = new Date();
          let dateMin = new Date(dateNow);
          dateMin.setDate(dateMin.getDate());
          if (dateMin.getDay() == "0") {
            dateMin.setDate(dateMin.getDate() + 1);
          }
          if (dateMin.getDay() == "6") {
            dateMin.setDate(dateMin.getDate() + 2);
          }
          let weekend = false;
          if (checkDate.getDay() == "0" || checkDate.getDay() == "6") {
            weekend = true;
          }
          if (checkDate >= dateMin && !weekend) {
            return false;
          }
          return true;
        }
      },

      dateFilterOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment()
                  .subtract(1, "week")
                  .format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment()
                  .subtract(1, "month")
                  .format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment()
                  .subtract(3, "months")
                  .format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last 6 months",
            onClick(picker) {
              const end = moment(moment().format("YYYY-MM-DD"))
                .add(1, "day")
                .subtract(1, "minute");
              const start = moment(
                moment()
                  .subtract(6, "months")
                  .format("YYYY-MM-DD")
              );
              picker.$emit("pick", [start, end]);
            }
          }
        ],
        disabledDate(time) {
          const difference = moment(time).diff(moment(), "days");
          return !(difference < 1);
        }
      },

      tableColumns: [
        {
          field: "sprite",
          title: "",
          width: 50,
          slots: {
            default: ({ row }) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-aqua" sprite="call-forward" />
                </div>
              ];
            }
          }
        },
        {
          field: "orderId",
          title: "Order Id",
          minWidth: 100,
          sortable: true
        },
        {
          title: "Account Name",
          minWidth: 250,
          sortable: true,
          showOverflow: true,
          slots: {
            default: () => {
              return [<span>{this.selectedTenant.name}</span>];
            },
          },
        },
        {
          field: 'customerOrderReference',
          title: 'PON',
          minWidth: 150,
          sortable: true
        },
        {
          field: 'createdDate',
          title: 'Order Date',
          minWidth: 150,
          sortable: true,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [<span>{this.portDateFormat(row.createdDate)}</span>];
            }
          }
        },
        {
          field: "orderStatus",
          title: "Status",
          minWidth: 150,
          sortable: true,
          showOverflow: true
        },
        {
          field: "desiredDueDate",
          title: "Req Date",
          minWidth: 150,
          sortable: true,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [<span>{this.portDateFormat(row.desiredDueDate)}</span>];
            }
          }
        },
        {
          field: "type",
          title: "Type",
          minWidth: 100,
          showOverflow: false
        },
        {
          field: "nextPortDate",
          title: "Next Port",
          sortable: true,
          showOverflow: true,
          minWidth: 150,
          slots: {
            default: ({ row }) => {
              return [<span>{this.nextPortDate(row)}</span>];
            }
          }
        },
        {
          field: "isOnDemand",
          title: "On Demand",
          sortable: true,
          showOverflow: true,
          minWidth: 100,
          slots: {
            default: ({ row }) => {
              return [<span>{this.isOnDemand(row)}</span>];
            }
          }
        },
        {
          field: "tnStatus",
          title: "TN Status",
          minWidth: 200,
          sortable: false,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div class="port-status">
                  {this.numberComplete(row) > 0 && (
                    <span class="status-complete">
                      <el-tag>{this.numberComplete(row)}</el-tag>
                    </span>
                  )}
                  {this.numberConfirmed(row) > 0 && (
                    <span class="status-confirmed">
                      <el-tag>{this.numberConfirmed(row)}</el-tag>
                    </span>
                  )}
                  {this.numberPending(row) > 0 && (
                    <span class="status-pending">
                      <el-tag>{this.numberPending(row)}</el-tag>
                    </span>
                  )}
                  {this.numberRejected(row) > 0 && (
                    <span class="status-rejected">
                      <el-tag>{this.numberRejected(row)}</el-tag>
                    </span>
                  )}
                </div>
              ];
            }
          }
        },
        {
          field: "activatePort",
          title: "",
          minWidth: 200,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <el-button
                  id={"activate-" + row.orderId}
                  v-show={this.activationsAvail(row)}
                  onClick={() => this.activatePortOrder(row.orderId)}
                >
                  Activate {this.activationsNumber(row)} Numbers
                </el-button>
              ];
            }
          }
        },
        {
          field: "actions",
          title: "",
          minWidth: 150,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div v-show={row.orderId === this.visibleActionsId}>
                  <el-button
                    id={"edit-" + row.orderId}
                    icon="el-icon-edit"
                    onClick={() => this.getOrder(row.orderId)}
                    class="table-action-button icon-blue"
                  />
                  <el-button
                    v-show={["Pending", "Incomplete"].includes(row.orderStatus)}
                    id={"delete-" + row.id}
                    type="danger"
                    icon="el-icon-delete"
                    size="mini"
                    onClick={() =>
                      this.cancelOrder(row.orderId, row.customerOrderReference)
                    }
                    class="table-action-button"
                  />
                </div>
              ];
            }
          }
        }
      ]
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.auth.user;
    }
  },

  watch: {
    selectedTenant() {
      this.queryOrders();
    },
    user() {
      this.queryOrders();
    }
  },

  methods: {
    ...mapActions("port-in-orders", {
      getPortOrder: "get",
      getAllOrders: "find",
      activateOrder: "update"
    }),

    handleCloseFilter() {
      this.filterVisible = false;
    },

    openCreate(type) {
      this.clearFields = false;
      this.createVisible = true;
      this.portType = type;
    },

    doPreset() {
      this.endDate = moment(moment().format("YYYY-MM-DD"))
        .add(1, "day")
        .subtract(1, "minute")
        .format("YYYY-MM-DD");
      this.startDate = moment()
        .subtract(180, "days")
        .format("YYYY-MM-DD");
      this.updateDateRangePicker();
      this.queryOrders();
    },

    doAdvanced() {
      this.advancedActive = true;
      this.startDate = moment(this.historyDateRange[0]).format("YYYY-MM-DD");
      this.endDate = moment(this.historyDateRange[1]).format("YYYY-MM-DD");
      this.updateDateRangePicker();
      this.queryOrders();
      this.handleCloseFilter();
    },

    filteredData() {
      return this.tableData
        .filter(
          data =>
            !this.filterType ||
            this.filterType === "All" ||
            data.type === this.filterType
        )
        .filter(
          data =>
            !this.search ||
            data.orderId
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            data.orderStatus
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            data.desiredDueDate
              .toLowerCase()
              .includes(this.search.toLowerCase())
        );
    },

    updateDateRangePicker() {
      this.historyDateRange = [moment(this.startDate), moment(this.endDate)];
    },

    cancelCreateOperation() {
      this.createVisible = false;
      this.clearFields = true;
    },

    cancelEditOperation() {
      this.editVisible = false;
      this.clearFields = true;
    },

    async handlePortRequest(context, data) {
      try {
        if (context === "phoneNumber") {
          const res = await feathersClient
            .service("number-porting")
            .create(data, { query: { context } });
          return res;
        }

        if (context === "tollFree") {
          const res = await fetch(
            `${hostServer}/number-porting?context=${context}`,
            {
              method: "POST",
              body: data,
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.accessToken}`
              }
            }
          );

          return res;
        }
      } catch (err) {
        console.log({ err });
        throw err;
      }
    },

    async submitNewRequest(context, orderData) {
      this.processing = true;

      this.handlePortRequest(context, orderData)
        .then(() => {
          setTimeout(() => {
            this.$notify({
              title: "Success",
              message: "Port Request has been created!",
              type: "success"
            });
            this.clearFields = true;
            this.createVisible = false;
            this.processing = false;
            this.queryOrders();
          }, 1000);
        })
        .catch(error => {
          if (error.hasOwnProperty("errors")) {
            this.$notify({
              title: error.message,
              message: error.errors[Object.keys(error.errors)[0]],
              type: "error"
            });
          } else {
            this.$notify({
              title: error.name,
              message: error.message,
              type: "error"
            });
          }
          this.processing = false;
        });
    },

    submitPortEdit(context, formData) {
      this.$confirm("Update Order Details", "Warning", {
        confirmButtonText: "Update",
        cancelButtonText: "Cancel"
      })
        .then(() => {
          this.processing = true;

          fetch(
            `${hostServer}/port-in-orders/${this.selectedPortOrder.id}?context=${context}&tenantId=${this.selectedTenant.id}`,
            {
              method: "PATCH",
              body: formData,
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.accessToken}`
              }
            }
          )
            .then(res => {
              setTimeout(() => {
                this.$notify({
                  title: "Success",
                  message: "Edited Order Submitted",
                  type: "success"
                });
                this.clearFields = true;
                this.editVisible = false;
                this.processing = false;
                this.queryOrders();
              }, 1000);
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
              this.processing = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Update Canceled"
          });
        });
    },

    getOrder(orderId) {
      this.modalModelId = orderId;
      this.editVisible = true;
      this.clearFields = false;
      this.processing = true;

      this.$store.commit("port-in-orders/clearList");

      this.getPortOrder(orderId)
        .then(res => {
          this.selectedPortOrder = res;
          this.processing = false;
        })
        .catch(error => {
          this.processing = false;
        });
    },

    //cancel the port order
    cancelOrder(orderId, customerOrderReference) {
      this.$confirm(`Cancel order ${orderId}`, "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.tableLoading = true;
          feathersClient
            .service("port-in-orders")
            .remove(orderId, { query: { customerOrderReference } })
            .then(() => {
              setTimeout(() => {
                this.$notify({
                  title: "Success",
                  message: "Deleted successfully!",
                  type: "success"
                });
                this.queryOrders();
              }, 1000);
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
              this.tableLoading = false;
            });
        })
        .catch(() => true);
    },

    //General Form and Table Operations
    cellClicked(data) {
      this.portType = data.row.type;
      const noClickCols = ["actions", "activatePort"];
      if (!noClickCols.includes(data.column.property)) {
        this.getOrder(data.row.orderId);
      }
    },

    rowHover(data) {
      this.visibleActionsId = data.row.orderId;
    },

    rowLeave() {
      this.visibleActionsId = "";
    },

    prettyNumber(number) {
      return phoneNumberFormatter(number);
    },

    numberConfirmed(row) {
      return parseInt(row.focTnQuantity);
    },

    numberPending(row) {
      const pendingQuantity =
        row.tnQuantity -
        (row.focTnQuantity + row.rejectedTnQuantity + row.activatedTnQuantity);
      return parseInt(pendingQuantity);
    },

    numberRejected(row) {
      return parseInt(row.rejectedTnQuantity);
    },

    numberComplete(row) {
      return parseInt(row.activatedTnQuantity);
    },

    activationsAvail(row) {
      let activationsAvailable = false;

      //this will loop through each of the foc items and determine if any numbers are available for activation today
      if (row.orderStatus === "Pending" && row.focList) {
        row.focList.focItem.forEach(item => {
          if (item.hasOwnProperty("portDate")) {
            let portDate = item.portDate.split("T")[0];
            let dateNow = new Date();
            let monthNow = dateNow.getMonth() + 1;
            let dayNow = dateNow.getDate();
            if (monthNow < 10) {
              monthNow = "0" + monthNow;
            }
            if (dayNow < 10) {
              dayNow = "0" + dayNow;
            }
            let checkDate =
              dateNow.getFullYear() + "-" + monthNow + "-" + dayNow;
            if (
              portDate == checkDate &&
              item.focTnQuantity > item.activatedTnQuantity
            ) {
              activationsAvailable = true;
            }
          }
        });
      }

      return activationsAvailable;
    },

    nextPortDate(row) {
      let portList = [];

      //this will grab the next scheduled port date.
      if (row.orderStatus === "Pending" && row.focList) {
        row.focList.focItem.forEach(item => {
          if (item.hasOwnProperty("portDate")) {
            const portDate = moment(item.portDate);
            portList.push(portDate.format("M/D/YY HH:mm") === "Invalid date"
              ? item.portDate
              : moment(item.portDate.split("T")[0]).format("M/D/YY HH:mm"))
          }
        });

        if (portList.length) {
          return portList.sort().join(", ");
        }

        return "N/A";
      }
    },

    isOnDemand(row) {
      //this will figure out if the order is on demand or not
      let onDemand = "N/A";
      if (row.orderStatus === "Pending" && row.focList) {
        for(let i = 0; i < row.focList.focItem.length; i++) {
          if (row.focList.focItem[i].hasOwnProperty("portDate")) {
            onDemand = moment(row.focList.focItem[i].portDate.split("T")[0]).format("HH:mm") === "00:00" ? "Y" : "N";
          }

          if(onDemand){
            break;
          }
        }
      }

      return onDemand;
    },

    activatePortOrder(orderId) {
      this.tableLoading = true;
      this.activateOrder([orderId, { action: "query" }])
        .then(res => {
          //build the html summary for the message box of the groups/numbers
          let activationData = res.data;
          let confirmMessage = `<div class="port-activate-confirm-message" style="max-height:300px; overflow: auto;">`;
          for (let i = 0; i < activationData.length; i++) {
            confirmMessage += `<h4 style="margin-bottom: 0;">${activationData[i].group}</h4>`;
            for (let k = 0; k < activationData[i].numbers.length; k++) {
              confirmMessage += `<p>${this.prettyNumber(
                activationData[i].numbers[k].toString()
              )}</p>`;
            }
          }
          confirmMessage += `</div>`;
          this.tableLoading = false;
          this.$confirm(confirmMessage, "Activation Summary", {
            confirmButtonText: "Activate",
            cancelButtonText: "Cancel",
            dangerouslyUseHTMLString: true
          })
            .then(() => {
              this.tableLoading = true;
              this.activateOrder([orderId, { action: "activate" }])
                .then(() => {
                  this.$notify({
                    title: "Success",
                    message:
                      "Activation Request Submitted. This update could take a while!",
                    type: "success"
                  });
                  this.tableLoading = false;
                })
                .catch(error => {
                  if (error.hasOwnProperty("errors")) {
                    this.$notify({
                      title: error.message,
                      message: error.errors[Object.keys(error.errors)[0]],
                      type: "error"
                    });
                  } else {
                    this.$notify({
                      title: error.name,
                      message: error.message,
                      type: "error"
                    });
                  }
                  this.tableLoading = false;
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "Activation Canceled"
              });
              this.tableLoading = false;
            });
          this.tableLoading = false;
        })
        .catch(error => {
          if (error.hasOwnProperty("errors")) {
            this.$notify({
              title: error.message,
              message: error.errors[Object.keys(error.errors)[0]],
              type: "error"
            });
          } else {
            this.$notify({
              title: error.name,
              message: error.message,
              type: "error"
            });
          }
          this.tableLoading = false;
        });
    },

    activationsNumber(row) {
      //this will loop through each of the orders and determine if any numbers are available for activation today
      let numberQuantity = 0;

      if (row.orderStatus === "Pending" && row.focList) {
        row.focList.focItem.forEach(item => {
          if (item.hasOwnProperty("portDate")) {
            let portDate = item.portDate.split("T")[0];
            let dateNow = new Date();
            let monthNow = dateNow.getMonth() + 1;
            let dayNow = dateNow.getDate();
            if (monthNow < 10) {
              monthNow = "0" + monthNow;
            }
            if (dayNow < 10) {
              dayNow = "0" + dayNow;
            }
            let checkDate =
              dateNow.getFullYear() + "-" + monthNow + "-" + dayNow;
            if (
              portDate == checkDate &&
              item.focTnQuantity > item.activatedTnQuantity
            ) {
              numberQuantity = item.focTnQuantity - item.activatedTnQuantity;
            }
          }
        });
      }

      return numberQuantity;
    },

    portDateFormat(val) {
      return val ? val.split("T")[0] : val;
    },

    queryOrders() {
      this.tableLoading = true;
      let params = {
        query: {
          orderRef: this.selectedTenant.tenantCode,
          startDate: this.startDate,
          endDate: this.endDate,
          orderStatus: this.orderStatus
        }
      };
      this.getAllOrders(params)
        .then(res => {
          this.tableData = res.filter(
            item =>
              item.customerOrderReference.split("-")[0] ===
              this.selectedTenant.tenantCode
          );
          this.tableLoading = false;
          this.$store.commit("port-in-orders/clearList");
        })
        .catch(err => {
          this.tableLoading = false;
        });
    }
  },

  async beforeMount() {
    const urlParams = new URLSearchParams(window.location.search);
    //this is if we link to create from dashboard.
    if (urlParams.has("context")) {
      const context = urlParams.get("context");
      if (context === "create") {
        this.createVisible = true;
      }
    }
  },

  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    //if linking from external src. set tenant and open order
    if (urlParams.has("tenantId") && urlParams.has("orderId")) {
      this.$store
        .dispatch("tenants/find", { query: { id: urlParams.get("tenantId") } })
        .then(res => {
          //console.log(res);
          this.$store.commit("setSelectedTenant", res[0]);
          this.doPreset();
          this.getOrder(urlParams.get("orderId"));
        });
    } else if (this.user) {
      this.doPreset();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables";

.modal-summary-table {
  max-width: 600px;
  margin: auto;
}

.tn-status-btn {
  padding: 6px 4px;
  margin: 2px 0;
  display: flex;
  justify-content: center;
  font-weight: 700;
}

.vxe-table {
  max-width: 600px;
  margin: auto;
}
</style>
